import { useMemo } from 'react'

import CustomSection from '@src/quince-site-common/src/domains/CustomSection'
import SectionRenderer from '@src/SectionRenderer'

import { SubCollection } from '../../domains/Collection'
import { getEnrichedCustomSection, shouldEnrichCustomSection } from '../../utils'

interface ICustomCollectionPageSection {
  filteredSubCollection: CustomSection | SubCollection
  filteredSubCollections: (CustomSection | SubCollection)[]
  isMounted: boolean
  slug: string
}

export const CustomCollectionPageSection: React.FC<ICustomCollectionPageSection> = ({
  filteredSubCollection,
  isMounted,
  filteredSubCollections,
  slug,
}) => {
  // Create the renderer function directly in component body (not inside hooks)
  const sectionRenderer = SectionRenderer({
    tracker: `collection_page__${slug}`,
  })

  // Memoize the enriched section data only
  const enrichedCustomSection = useMemo(
    () => getEnrichedCustomSection(filteredSubCollection as CustomSection, filteredSubCollections),
    [filteredSubCollection, filteredSubCollections],
  )

  if (filteredSubCollection.typename !== 'CustomSection') return <></>

  // Call the renderer during render phase
  if (shouldEnrichCustomSection(filteredSubCollection) && isMounted) {
    return sectionRenderer(enrichedCustomSection)
  }
  return sectionRenderer(filteredSubCollection as CustomSection)
}
